import {
    createContext,
    useContext,
    useEffect,
    useState,
    useRef,
    useMemo,
} from 'react';
import GlobalService from '../../services/Global.service';

export const DpiaContext = createContext(null);

export const DpiaProvider = ({ children }) => {
    const ref = useRef();
    const refSave = useRef();
    const [identificationList, setIdentificationList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState([]);
    const [setselectStatus, setSetselectStatus] = useState('');
    const [impact, setImpact] = useState([]);
    const [measures, setMeasures] = useState([]);
    const [wizard, setWizard] = useState();
    const [dataflow, setDataflow] = useState();
    const [error, setError] = useState(false);
    const [step1, setStep1] = useState(true);
    const [step2, setStep2] = useState(true);
    const [step3, setStep3] = useState(true);
    const [step4, setStep4] = useState(true);
    const [step5, setStep5] = useState(true);
    const [step7, setStep7] = useState(true);
    const [isPreview, setIsPreview] = useState(false);
    const [step2State, setStep2State] = useState({value: 0,  timestamp: Date.now()});
    const [stepNo, setStepNo] = useState(0);

    useEffect(() => {
        const getStatus = async () => {
            try {
                const { data } = await GlobalService.getStatus({
                    type: 'dpia',
                });
                if (data?.resultData) {
                    setStatus(data.resultData);
                    setSetselectStatus(data.resultData[0].statusId);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatus();
    }, []);

    const stores = useMemo(() => {
        return {
            ref,
            refSave,
            identificationList,
            setIdentificationList,
            loading,
            setLoading,
            status,
            setStatus,
            setselectStatus,
            setSetselectStatus,
            impact,
            setImpact,
            measures,
            setMeasures,
            wizard,
            setWizard,
            dataflow,
            setDataflow,
            error,
            setError,
            step1,
            setStep1,
            step5,
            setStep5,
            step7,
            setStep7,
            isPreview,
            setIsPreview,
            step2,
            step3,
            step4,
            setStep2,
            setStep3,
            setStep4,
            step2State,
            setStep2State,
            setStepNo,
            stepNo
        };
    }, [
        ref,
        refSave,
        identificationList,
        loading,
        status,
        setselectStatus,
        impact,
        measures,
        wizard,
        dataflow,
        error,
        step1,
        step5,
        step7,
        isPreview,
        step2,
        step3,
        step4,
        step2State,
        stepNo
    ]);

    return (
        <DpiaContext.Provider value={stores}>{children}</DpiaContext.Provider>
    );
};

export const useDpiaContext = () => useContext(DpiaContext);
